import { useEffect, useState, useCallback } from 'react'
import { AvatarSpecial } from 'ui/components/AvatarSpecial'
import { AVATAR_TYPE } from 'ui/components/AvatarSpecial/constants'
import { Letter, Logo } from './styled'

export const CardLogo = ({
  isUploader = false,
  name = '☹',
  logo = null,
  isApi,
  width = 32,
  height = 32,
  style,
}) => {
  const [hasError, setHasError] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setHasError(false)
    setIsLoaded(false)
  }, [logo])

  const handleLoad = useCallback(() => {
    setIsLoaded(true)
  }, [])

  const handleLoadError = useCallback(() => {
    setHasError(true)
  }, [])

  if (!logo || hasError) {
    return (
      <Letter
        style={style}
        $isUploader={isUploader}
        $height={height}
        $width={width}
      >
        {name[0]}
      </Letter>
    )
  }

  return (
    <Logo
      style={style}
      isUploader={isUploader}
      $height={height}
      $width={width}
      $isLoaded={isLoaded}
    >
      {!isLoaded && (
        <Letter
          $isUploader={isUploader}
          $height={height}
          $width={width}
          $isOverlay
        >
          {name[0]}
        </Letter>
      )}

      <AvatarSpecial
        src={logo}
        isApi={isApi}
        alt={isLoaded ? name : ''}
        type={AVATAR_TYPE.PROJECT}
        onLoad={handleLoad}
        onLoadError={handleLoadError}
      />
    </Logo>
  )
}
